import RestService from "../helpers/RestService";
import {ajaxUrls} from "../settings/routes";
import {toastr} from 'react-redux-toastr'

let usersActions;
usersActions = {
    toggleOpenUserModal: (show) => ({
        type: 'TOGGLE_USER_MODAL',
        show,
    }),
    getUsers: (body={}) => {
        return (dispatch) => {
            dispatch({
                type: 'GET_USERS_LOADING'
            })
            RestService.customFetchRes(ajaxUrls.getUsers, {}, {data: body})
                .then(({payload, total}) => {
                        dispatch({
                            type: 'GET_USERS_SUCCESS',
                            list: payload,
                            total,
                        })
                    }
                )
        }
    },
    setStatus: (id, status) => {
        return (dispatch, getState) => {
            const {users} = getState();
            RestService.customFetchRes(ajaxUrls.setUserStatus, {}, {data: {id, status}})
                .then((res) => {
                        toastr.success('Success', 'Status was changed')
                        dispatch({
                            type: 'CHANGE_USERS_SUCCESS',
                            list: users.list.map(user => {
                                if (user.id === id) {
                                    return {
                                        ...user,
                                        status
                                    }
                                }
                                return user
                            })
                        })
                    }
                ).catch(err => console.error(err))
        }
    },
    setAccount: (id, type) => {
        return (dispatch, getState) => {
            const {users} = getState();
            RestService.customFetchRes(ajaxUrls.setUserType, {}, {data: {id, type}})
                .then(() => {
                    toastr.success('Success', 'Account Type was changed')
                    dispatch({
                            type: 'CHANGE_USERS_SUCCESS',
                            list: users.list.map(user => {
                                if (user.id === id) {
                                    return {
                                        ...user,
                                        account: type
                                    }
                                }
                                return user
                            })
                        })
                    }
                )
        }
    },
    // sort

};
export default usersActions



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/actions/usersActions.js